export enum MonitoringAssetStatusEnum {
  Active = 0,
  Inactive,
  Identified,
  Upcoming,
}

export const MONITORING_ASSET_MAPPER = {
  [MonitoringAssetStatusEnum.Active]: 'Active',
  [MonitoringAssetStatusEnum.Inactive]: 'Inactive',
  [MonitoringAssetStatusEnum.Identified]: 'Identified',
  [MonitoringAssetStatusEnum.Upcoming]: 'Coming soon',
};

export enum MonitoringAssetCategoryEnum {
  TvAndPle = 0,
  Talents,
  Anime,
  Games,
  Movies,
  Music,
  Ecommerce,
  TVSeries,
  Videos,
}

export const MONITORING_CATEGORY_MAPPER = {
  [MonitoringAssetCategoryEnum.TvAndPle]: 'Tv And Ple',
  [MonitoringAssetCategoryEnum.Talents]: 'Talents',
  [MonitoringAssetCategoryEnum.Anime]: 'Anime',
  [MonitoringAssetCategoryEnum.Games]: 'Games',
  [MonitoringAssetCategoryEnum.Movies]: 'Movies',
  [MonitoringAssetCategoryEnum.Music]: 'Music',
  [MonitoringAssetCategoryEnum.Ecommerce]: 'Ecommerce',
  [MonitoringAssetCategoryEnum.TVSeries]: 'TV Series',
  [MonitoringAssetCategoryEnum.Videos]: 'Videos',
};
